import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import about from '@/components/about'
import destinations from '@/components/destinations'
import packages from '@/components/packages'
import howDoWeDo from '@/components/how_do_we_do'
import contact from '@/components/contact'
Vue.use(Router)
/* mode: 'history', */
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/destinations',
      name: 'destinations',
      component: destinations
    },
    {
      path: '/packages',
      name: 'packages',
      component: packages
    },
    {
      path: '/how_do_we_do',
      name: 'how_do_we_do',
      component: howDoWeDo
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    }
  ],
  linkActiveClass: 'menuLinkActive',
  linkExactActiveClass: 'menuLinkActive'
})



// WEBPACK FOOTER //
// ./src/router/index.js